import http from '@/utils/request'

//开屏页接口
export function GET_TAIL (data) {

  return http({

    url: '/open/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//官网首页接口
export function UNI_ALUB_IMDEX (data) {

  return http({

    url: '/uni_club/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//关于我们接口
export function GET_ABOUT (data) {

  return http({

    url: '/about/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}

//活动列表接口
export function GET_ACTIVE (data) {

  return http({

    url: '/active/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}

//活动列表详情接口
export function GET_ACTIVE_Details (data) {

  return http({

    url: '/active/detail',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//联系我们接口-
export function GET_RELATE (data) {

  return http({

    url: '/relate/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//APP下载-
export function GET_DOWNLOAD (data) {

  return http({

    url: '/download/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//友情链接接口-
export function GET_FOOTER (data) {

  return http({

    url: '/foot/index',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}



//通过手机号查询对应的票券编号
export function GET_PHONE_RELATE_TICKET (data) {

  return http({

    url: '/mod/phone_relate_ticket',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}

//校验票券编号是否正确
export function GET_TICKET_NUMBER_CHECK (data) {

  return http({

    url: '/mod/ticket_number_check',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}

//mod背景轮播图
export function GET_MOD_BACK_BANNER (data) {

  return http({

    url: '/mod/mod_back_banner/',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}


//mod购买指引
export function GET_MOD_GUIDE (data) {

  return http({

    url: '/mod/mod_guide/',

    method: 'post',

    data,

    isShowLoading: true   //是否显示loading

  })

}



// WEBPACK FOOTER //
// ./src/api/mall.js